import { NDC_TABS_DATA } from '../../NDC/utility/constants';
import { planTypeList, quarterOptionList, selectOneOptionList } from '../components/URASearch';
import * as actionTypes from './actionTypes';

const URASearchInitialState = {
  loading: false,
  errorMessages: [],
  successMessages: [],
  URASearchFormValues: {
    planType: '',
    selectOneOption: null,
    rebateProgramCd: '-1',
    quarters: quarterOptionList[0].value,
    quarter: '',
    searchType: NDC_TABS_DATA[0].value,
  },
  rebateProgramCode: {},
  manufacturersData: [],
  manufacturerSelectedRows: [],
  DrugFamilyTableData: [],
  drugFamilySelectedRows: [],
  searchByDrugNameTableData: [],
  labelerDrugTableData: [],
  labelerTableData: [],
  userDefaults: {},
  defaultQtrRIC: {},

};

const URADetailInitailState = {
  URADetailsTableData: [],
  URADetailsTableRowSelected: [],
  topGridTableData: [],
  childGridDetailListTableData: [],
  bottomGridTableData: [],
  calculatedURAHeaderDataList: [],
  calculatedURAHeaderData: null,
  calculatedURAIndex: 0,
  calculatedURAErrorMessage: '',
}; 

const initilaState = {
  ...URASearchInitialState,
  ...URADetailInitailState,
}

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.URA_SEARCH_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.SET_ERROR_MESSAGES: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.SET_SUCCESS_MESSAGES: {
      return { ...state, successMessages: action.payload };
    }
    case actionTypes.SET_URA_SERCH_FORM_VALUES: {
      return { ...state, URASearchFormValues: action.payload };
    }
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.GET_MANUFACTURER_LIST: {
      return { ...state, manufacturersData: action.payload };
    }
    case actionTypes.SET_MANUFACTURER_SELECTED_ROWS: {
      return { ...state, manufacturerSelectedRows: action.payload };
    }
    case actionTypes.GET_URA_DETAILS_TABLE_DATA: {
      return { ...state, URADetailsTableData: action.payload };
    }
    case actionTypes.SET_DRUG_FAMILY_TABLE_DATA: {
      return { ...state, DrugFamilyTableData: action.payload };
    }
    case actionTypes.SET_DRUG_FAMILY_SELECTED_ROWS: {
      return { ...state, drugFamilySelectedRows: action.payload };
    }
    case actionTypes.URA_DETAILS_TABLE_ROW_SELECTED: {
      return { ...state, URADetailsTableRowSelected: action.payload };
    }
    case actionTypes.URA_SEARCH_BY_DRUG_NAME_TABLE_DATA: {
      return { ...state, searchByDrugNameTableData: action.payload };
    }
    case actionTypes.URA_LABELER_DRUG_TABLE_DATA: {
      return { ...state, labelerDrugTableData: action.payload };      
    }
    case actionTypes.URA_LABELER_TABLE_DATA: {
      return { ...state, labelerTableData: action.payload };
    }
    case actionTypes.SET_CALCULATED_URA_HEADER_DATA_LIST: {
      return { ...state, calculatedURAHeaderDataList: action.payload };
    }
    case actionTypes.SET_CALCULATED_URA_HEADER_DATA: {
      return { ...state, calculatedURAHeaderData: action.payload };
    }
    case actionTypes.SET_TOP_GRID_TABLE_DATA: {
      return { ...state, topGridTableData: action.payload };
    }
    case actionTypes.SET_CHILD_GRID_DETAIL_LIST: {
      return { ...state, childGridDetailListTableData: action.payload };
    }
    case actionTypes.SET_GOV_GRID_NDC_DETAIL_LIST: {
      return { ...state, bottomGridTableData: action.payload };
    }
    case actionTypes.SET_CALCULATED_URA_INDEX: {
      return { ...state, calculatedURAIndex: action.payload };
    }
    case actionTypes.GET_USER_DEFAULTS: {
      return { ...state, userDefaults: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrRIC: action.payload };
    }
    case actionTypes.SET_CALCULATED_URA_ERROR: {
      return { ...state, calculatedURAErrorMessage: action.payload };
    }
    case actionTypes.RESET_URA_SEARCH_STORE: {
      return { ...state, ...URASearchInitialState };
    }
    case actionTypes.RESET_URA_DETAIL_STORE: {
      return { ...state, ...URADetailInitailState };
    }
    default:
      return state;
  }
};

export default reducer;